import { render } from "./DocumentTemplatesArchive.vue?vue&type=template&id=e5c51380&scoped=true"
import script from "./DocumentTemplatesArchive.vue?vue&type=script&lang=js"
export * from "./DocumentTemplatesArchive.vue?vue&type=script&lang=js"

import "./DocumentTemplatesArchive.vue?vue&type=style&index=0&id=e5c51380&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5c51380"]])

export default __exports__